import React, { useContext, useMemo, useState } from 'react';
import { PostForm } from './components/PostForm';
import { CommentsList } from './components/CommentsList';
import { AppContext } from '../../../../AppContext';
import './Comments.scss';

export function Comments({ disabled, comments, onKarma, onPost, onLoadMore, title }) {
  const { user } = useContext(AppContext);
  const [commentParent, setCommentParent] = useState(0);

  const commentsCount = useMemo(() => {
    function getCommentsCount(comments) {
      let count = 0;

      comments.forEach((comment) => {
        count++;
        if(comment.replies) {
          count += getCommentsCount(comment.replies);
        }
      });

      return count;
    }

    return getCommentsCount(comments.comments_posts);
  }, [comments]);

  function onReply(parent, text) {
    // actid=24
    window.analytics?.track("reply_comment:click", {
      "text": text,
      "title": title,
      "url": window.location.href
    });

    setCommentParent(parent);
  }

  function handleCancelPost() {
    setCommentParent(0);
  }

  function handlePost(comment) {
    setCommentParent(0);
    onPost(commentParent, comment);
  }

  return (
    <div className="Comments">
      <h3 className="Comments__title">{commentsCount} comments</h3>

      {user.type !== 'guest' && commentParent === 0 && (
        <PostForm disabled={disabled} onPost={handlePost} />
      )}

      {!!comments.comments_posts.length && (
        <CommentsList
          disabled={disabled}
          comments={comments.comments_posts}
          replyId={commentParent}
          onKarma={onKarma}
          onCancelPost={handleCancelPost}
          onReply={onReply}
          onReplyPost={handlePost}
        />
      )}

      {comments.per_page > 0 && comments.per_page !== comments.comments_found && (
        <button
          type="button"
          className="Comments__more-btn"
          onClick={onLoadMore}
        >
          Load more
        </button>
      )}
    </div>
  );
}
